var _mask, _path, _path2, _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_1_279",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 9.45703C0 4.23406 4.23406 0 9.45703 0C14.68 0 18.9141 4.23406 18.9141 9.45703C18.9141 14.68 14.68 18.9141 9.45703 18.9141C4.23406 18.9141 0 14.68 0 9.45703Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.45703C0 4.23406 4.23406 0 9.45703 0C14.68 0 18.9141 4.23406 18.9141 9.45703C18.9141 14.68 14.68 18.9141 9.45703 18.9141C4.23406 18.9141 0 14.68 0 9.45703Z",
    fill: "#155DFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.45703M18.9141 9.45703M18.9141 9.45703M0 9.45703M9.45703 0M18.9141 9.45703M9.45703 18.9141M0 9.45703M9.45703 18.9141V17.7927C4.85336 17.7927 1.12135 14.0607 1.12135 9.45703H0H-1.12135C-1.12135 15.2993 3.61475 20.0354 9.45703 20.0354V18.9141ZM18.9141 9.45703H17.7927C17.7927 14.0607 14.0607 17.7927 9.45703 17.7927V18.9141V20.0354C15.2993 20.0354 20.0354 15.2993 20.0354 9.45703H18.9141ZM9.45703 0V1.12135C14.0607 1.12135 17.7927 4.85336 17.7927 9.45703H18.9141H20.0354C20.0354 3.61475 15.2993 -1.12135 9.45703 -1.12135V0ZM9.45703 0V-1.12135C3.61475 -1.12135 -1.12135 3.61475 -1.12135 9.45703H0H1.12135C1.12135 4.85336 4.85336 1.12135 9.45703 1.12135V0Z",
    fill: "#155DFC",
    mask: "url(#path-1-inside-1_1_279)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_279)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6079 7.09402L8.27545 11.4265L6.30615 9.45718",
    stroke: "white",
    strokeWidth: 1.57544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_279"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.45262,
    height: 9.45262,
    fill: "white",
    transform: "translate(4.73096 4.73068)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/CheckCircle.f3e8f74ab7ab7e3402d7074c93f13663.svg";
export { ForwardRef as ReactComponent };